import { BillingCard } from "./billing-card";
import { Subscription } from "./subscription";

export class BillingDetails {
    private _customerId:string;
    private _email:string;
    private _cards:BillingCard[];
    private _subscriptions:Subscription[];

    constructor() {
        this._cards = [];
        this._subscriptions = [];
        // let sub = new BillingSubscription("Active");
        // sub.dateCanceled = new Date();
        // sub.dateRenewal = new Date();
        // sub.id = "Sub-1";
        // sub.name = "Discover and Change Membership";
        // sub.price = 2230;
        // sub.quantity = 77;
        // sub.unit = "Users";
        // this._subscriptions = [sub];
    }

    public get subscriptions() : Subscription[] {
        return this._subscriptions;
    }

    public set subscriptions(v:Subscription[]) {
        this._subscriptions = v;
    }
    

    /**
     * Getter email
     * @return {string}
     */
	public get email(): string {
		return this._email;
	}

    /**
     * Setter email
     * @param {string} value
     */
	public set email(value: string) {
		this._email = value;
	}
    

    /**
     * Getter customerId
     * @return {string}
     */
	public get customerId(): string {
		return this._customerId;
	}

    /**
     * Setter customerId
     * @param {string} value
     */
	public set customerId(value: string) {
		this._customerId = value;
	}

    /**
     * Getter cards
     * @return {BillingCard[]}
     */
	public get cards(): BillingCard[] {
		return this._cards;
	}

    /**
     * Setter cards
     * @param {BillingCard[]} value
     */
	public set cards(value: BillingCard[]) {
		this._cards = value;
    }
    
    public hasCards() {
        return this.cards && this.cards.length > 0;
    }

    public hasSubscriptions() {
        return this.subscriptions && this.subscriptions.length > 0;
    }
    
}


// WEBPACK FOOTER //
// ./src/app/shared/models/billing-details.ts